import { betPositionSagas } from './betPosition';
import { fairPlaySagas } from './fairPlay';
import { checkoutInfoSagas } from './checkoutInfo';

export const ServicePickerWidgetSagas = [betPositionSagas, fairPlaySagas, checkoutInfoSagas];
